module.exports = __webpack_public_path__ + "static/media/yajun.93a14f52.png";